import { UserFacingError } from './api';

/** Converts any thrown value into a message that's safe to show end users. */
export function toFriendlyMessage(err: unknown): string {
  if (err instanceof UserFacingError) return err.message;
  if (err instanceof Error) console.error(err);
  return 'Something went wrong. Please try again.';
}

export function retryExhaustedMessage(): string {
  return 'Upload failed after multiple attempts. Please check your connection and try again.';
}
